import {
  cdnResourceListGql,
  addCdnResourceGql,
  deleteCdnResourceGql,
} from '@/graphql/gql/cdn_resource';
import { calVariables, request } from '@/graphql/util';

export function cdnResourceList(data) {
  return request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(cdnResourceListGql, data),
  });
}

export function addCdnResource(data) {
  return request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(addCdnResourceGql, data),
  });
}

export function deleteCdnResource(data) {
  return request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(deleteCdnResourceGql, data),
  });
}

